import React from "react";
import { Box, Container, Grid, Typography, Divider, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const Footer = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: "linear-gradient(180deg, #03192b 0%, #002543 100%)",
        pt: { xs: 5, md: 8 },
        pb: { xs: 5, md: 6 },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 3, md: 6 }}>

          <Grid item xs={12} sm={6} md={4}>
            <Typography
              sx={{
                fontSize: 22,
                fontWeight: 700,
                color: "#ffffff",
              }}
            >
              ArthGyan
            </Typography>

            <Typography
              sx={{
                mt: 2,
                fontSize: 14,
                color: "#b8e2df",
                maxWidth: { xs: "100%", md: 320 },
                lineHeight: 1.7,
              }}
            >
              Empowering investors with knowledge and the right tools to achieve
              financial independence. Trusted AMFI-registered distributor for
              Mutual Funds in India.
            </Typography>

            <Box sx={{ display: "flex", gap: 3, mt: 3, flexWrap: "wrap" }}>
              <Box
                component="a"
                href="https://www.linkedin.com/company/arthgyan9/?viewAsMember=true"
                target="_blank"
                sx={{ color: "#ffffff", opacity: 0.85 }}
              >
                <LinkedInIcon sx={{ fontSize: 28 }} />
              </Box>

              <Box
                component="a"
                href="https://wa.me/919595027710"
                target="_blank"
                sx={{ color: "#25D366" }}
              >
                <WhatsAppIcon sx={{ fontSize: 28 }} />
              </Box>

              <Box
                component="a"
                href="https://www.instagram.com/govtemployeesgyan"
                target="_blank"
                sx={{ color: "#E4405F" }}
              >
                <InstagramIcon sx={{ fontSize: 28 }} />
              </Box>

              <Box
                component="a"
                href="https://www.youtube.com/@governmentemployeesgyan"
                target="_blank"
                sx={{ color: "#FF0000" }}
              >
                <YouTubeIcon sx={{ fontSize: 28 }} />
              </Box>
            </Box>
          </Grid>

          {/* COMPANY */}
          <Grid item xs={6} sm={6} md={2}>
            <Typography sx={{ color: "#ffffff", mb: 2, fontWeight: 600 }}>
              Company
            </Typography>

            {[
              { label: "FAQ", path: "/faq" },
              { label: "Grievance Redressal Policy", path: "/grievance-redressal-policy" },
              { label: "Refund and Cancellation Policy", path: "/refund-policy" },
            ].map((item) => (
              <Typography
                key={item.label}
                component={RouterLink}
                to={item.path}
                sx={{
                  display: "block",
                  color: "#b8e2df",
                  mb: 1,
                  fontSize: 14,
                  textDecoration: "none",
                  "&:hover": { color: theme.palette.primary.main },
                }}
              >
                {item.label}
              </Typography>
            ))}
          </Grid>

          <Grid item xs={6} sm={6} md={2}>
            <Typography sx={{ color: "#ffffff", mb: 2, fontWeight: 600 }}>
              Services
            </Typography>

            {["Investments", "Insurance", "Banking", "Retirement"].map((item) => (
              <Typography
                key={item}
                sx={{ color: "#b8e2df", mb: 1, fontSize: 14 }}
              >
                {item}
              </Typography>
            ))}
          </Grid>

          <Grid item xs={6} sm={6} md={2}>
            <Typography sx={{ color: "#ffffff", mb: 2, fontWeight: 600 }}>
              Legal
            </Typography>

            <Typography
              component={RouterLink}
              to="/privacy-policy"
              sx={{
                display: "block",
                color: "#b8e2df",
                mb: 1,
                fontSize: 14,
                textDecoration: "none",
                "&:hover": { color: theme.palette.primary.main },
              }}
            >
              Privacy Policy
            </Typography>

            <Typography
              component={RouterLink}
              to="/terms-and-conditions"
              sx={{
                display: "block",
                fontSize: 14,
                color: "#b8e2df",
                textDecoration: "none",
                "&:hover": { color: theme.palette.primary.main },
              }}
            >
              Terms & Conditions
            </Typography>
          </Grid>
        </Grid>

        <Box
          sx={{
            mt: 6,
            px: { xs: 2, md: 4 },
            py: 3,
            // background: "#071f1e",
            borderRadius: "10px",
          }}
        >
          <Typography
            sx={{
              color: "#9adad4",
              fontSize: 14,
              lineHeight: 1.7,
              textAlign: "center",
            }}
          >
            Mutual Fund investments are subject to market risks. Read all scheme
            related documents carefully. Past performance is not indicative of
            future returns.
            <br /><br />

            <strong>GST No:</strong> 36ABACA5696C1ZP
            <br />

            Arthagyani Technology Private Limited is an
            <strong> AMFI-registered Mutual Fund Distributor</strong> (ARN-320330).
            <br />

            <strong>Date of Initial Registration:</strong> 30-JAN-2025
            <br />
            <strong>Validity of ARN:</strong> 29-JAN-2028
            <br /><br />

            Complaints or queries? Email us at&nbsp;
            <Box
              component="a"
              href="mailto:support@arthgyan.com"
              sx={{
                color: theme.palette.primary.main,
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              support@arthgyan.com
            </Box>
          </Typography>
        </Box>

        <Divider sx={{ my: 5, borderColor: "rgba(255,255,255,0.12)" }} />

        <Grid container justifyContent="center">
          <Typography sx={{ color: "#9adad4", fontSize: 12 }}>
            © {new Date().getFullYear()} Arthagyani Technology Pvt. Ltd. All rights reserved.
          </Typography>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
